'use client';

import { createContext, useContext, useEffect } from 'react';
import { useThemes } from '@/creditflowresearch/application/hooks/apiHooks/useThemes';
import type { IMarketTheme } from '@/creditflowresearch/domain/vo/ArticlesAndStats/IMarketTheme';

const useArticlesMarketThemes = () => {
  const { fetch, isFetching, collection, isInitialized } = useThemes();

  useEffect(() => {
    fetch();
  }, []);

  return { themes: collection as IMarketTheme[], isInitialized, isFetching };
};

type ArticlesMarketThemesContextType = ReturnType<typeof useArticlesMarketThemes>;

export const ArticlesMarketThemesContext = createContext<ArticlesMarketThemesContextType | null>(null);

export const useArticlesThemesContext = () => {
  const context = useContext(ArticlesMarketThemesContext);

  if (!context) {
    throw new Error('useArticlesThemesContext must be used within a ArticlesThemesContextProvider');
  }

  return context;
};

const ArticlesMarketThemesContextProvider = ({ children }) => (
  <ArticlesMarketThemesContext.Provider value={ useArticlesMarketThemes() }>
    { children }
  </ArticlesMarketThemesContext.Provider>
);

export default ArticlesMarketThemesContextProvider;
